import { useEffect, useState } from 'react'
import { CustomClassifier } from 'routes/TableFilter'
import { sortBySortOrder } from 'helpers'
import { UserPreference } from 'types/UserPreference'
import { useQueryClient } from '@tanstack/react-query'
import { toUserPreferences, toUserPreferencesUpdateRequest } from './mapper'
import TransitApiConfig from '../../../TransitOperationEditor/hooks/apiConfig'
import useUserPreferenceApi, { updateUserPreferences } from './api'

function useUserPreference() {
  const queryClient = useQueryClient()
  const { fetchUserPreferences } = useUserPreferenceApi()

  const [userPreferences, setUserPreferences] = useState<Array<UserPreference>>([])
  const [isPreferencesLoading, setIsPreferencesLoading] = useState<boolean>(true)

  const getUserPreferences = () => fetchUserPreferences.data

  useEffect(() => {
    const { data } = fetchUserPreferences
    if (data) {
      data.sort(sortBySortOrder)
      const preferences = data.map((item) => toUserPreferences(item))

      setUserPreferences(preferences.length !== 0 ? preferences : [])
      setTimeout(() => {
        setIsPreferencesLoading(false)
      }, 500)
    } else {
      setTimeout(() => {
        setIsPreferencesLoading(false)
      }, 500)
    }
  }, [fetchUserPreferences.data])

  const createOrUpdateUserPreferences = async (data: CustomClassifier[]) => {
    const preferences = data.map((preference) => toUserPreferencesUpdateRequest(preference))

    const updated = await updateUserPreferences(preferences)
    await queryClient.invalidateQueries({ queryKey: TransitApiConfig.paths.userPreferences.queryKeys.getUserPreferences() })
    return updated
  }

  return {
    getUserPreferences,
    userPreferences,
    setUserPreferences,
    createOrUpdateUserPreferences,
    isPreferencesLoading,
  }
}

export default useUserPreference
